import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import PHConfig from "../ph.config";
import PHDialog from "./components/PhDialog";
import axiosUtil from "@src/utils/axiosoUtil";

Vue.config.productionTip = true;
Vue.config.devtools = process.env.NODE_ENV === "development";
if (process.env.NODE_ENV === "development") {
  axiosUtil
    .post(axiosUtil.api.TEST, {
      // openId: "odkUIjxsiLdjLNzokZ9zyrn55jX4"
      // openId: "odkUIj3gkjq9ZW5Xih4H8Qn4Ga8E"
      // openId: "odkUIj65MjxVA3xqTnllPZm_MZFQ"
      openId: "odkUIj8Imq1rqWzl-irQKlDk6LfE"
    })
    .then(({ token, refreshToken }) => {
      localStorage.setItem("token", token);
      localStorage.setItem("refreshToken", refreshToken);
    });
}
Vue.use(PHConfig);
Vue.use(PHDialog);

new Vue({
  render: h => h(App),
  router,
  store
}).$mount("#app");
